import { join, slice } from 'lodash';

const addRoutesToAreas = areas => {

  const areasByDocumentId = new Map(areas.map(area => [area.documentId, area]));

  const getRoute = area => {
    const parents = [];
    let current = area;

    while (current) {
      parents.unshift(current.slug);
      current = areasByDocumentId.get(current.parent_area?.documentId);
    }

    return join(parents, '/');
  };

  return areas.map(area => {
    if (!area.parent_area) {
      return { ...area, route: '/' };
    }

    const route = getRoute(area);
    const parent = areasByDocumentId.get(area.parent_area.documentId);
    const pathArray = route.split('/');
    const parentRoute = `${slice(pathArray, 0, pathArray.length - 1).join('/')}`;

    return {
      ...area,
      route,
      parent_area: {
        ...area.parent_area,
        route: parentRoute,
        background: parent?.background || area.parent_area.background || null,
        transition_out: parent?.transition_out || area.parent_area.transition_out || null
      }
    };
  });

};

export default addRoutesToAreas;
